<template>
  <div v-if="session">
    <h2>PEGAWAI NEGERI SIPIL</h2>

    <v-divider class="mt-3 mb-7"></v-divider>

    <div>
      <v-row>
        <v-col cols="12" md="10">
          <v-card class="px-2 py-5" outlined>
            <v-col cols="12">
              <v-row>
                <v-col cols="12" md="2">
                  <v-img :src="foto" v-if="foto"></v-img>
                  <v-img src="@/assets/gambar/no_pic_male.png" v-else></v-img>

                  <v-btn
                    block
                    color="primary"
                    x-small
                    depressed
                    class="mt-2"
                    @click="editPhoto()"
                    v-if="
                      session.authorities.some(
                        (item) => item === 'CRUD_ADMINISTRATOR',
                      )
                    "
                  >
                    EDIT FOTO
                  </v-btn>
                </v-col>

                <v-col cols="12" md="10" class="mt-5" v-if="data">
                  <div class="mb-5">
                    <h1>
                      {{ data.nama }}
                    </h1>
                  </div>

                  <div v-if="rwjabatan">
                    <v-row v-if="rwjabatan.unor">
                      <v-col cols="12" md="6">
                        <div class="mb-5">
                          <strong> Unit Organisasi Induk : </strong>
                          <div>
                            {{ rwjabatan.unor.induk.nama.toUpperCase() }}
                          </div>
                        </div>

                        <div v-if="rwjabatan.unor">
                          <strong> Unit Organisasi : </strong>
                          <div>{{ rwjabatan.unor.nama.toUpperCase() }}</div>
                        </div>
                      </v-col>

                      <v-col cols="12" md="6">
                        <div class="mb-5">
                          <strong> Nomor Induk Pegawai : </strong>
                          <div>{{ data.nipBaru }}</div>
                        </div>

                        <div class="mb-5">
                          <strong> Jabatan : </strong>
                          <div v-if="rwjabatan.nama_jabatan">
                            {{ rwjabatan.nama_jabatan.toUpperCase() }}
                          </div>
                          <div v-else>-</div>
                        </div>
                      </v-col>
                    </v-row>
                  </div>

                  <div v-else>
                    <v-alert text type="error">
                      Data Posisi Dan Jabatan Anda Masih Kosong! Silahkan
                      Menghubungi <strong>Admin BKPSDM</strong></v-alert
                    >
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-card>
        </v-col>

        <v-col cols="12" md="2" v-if="data">
          <v-card class="pa-3 caption" color="primary" dark v-if="data.data">
            <div
            class="float-right"
              v-if="
                session.authorities.some(
                  (item) => item === 'CRUD_ADMINISTRATOR',
                )
              "
            >
              <v-btn outlined @click="open_modal_statusdata()" fab text small>
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </div>

            <div class="mb-2">
              <v-img
                class="mx-auto"
                src="@/assets/gambar/logo-warna.png"
                max-width="100"
              ></v-img>
            </div>

            <div >
              <h4>Status Data :</h4>
              {{ data.data.status }}
            </div>

            <v-divider class="my-1"></v-divider>

            <div>
              <h4>Keterangan Data :</h4>
              {{ data.statusData }}
            </div>

            <v-divider class="my-1"></v-divider>

            <div>
              <h4>Update Terakhir :</h4>
              {{ fwaktu(data.NCSISTIME) }}
            </div>

            <v-divider class="my-1"></v-divider>

            <div>
              <h4>Rekomendasi Update :</h4>
              {{ fwaktu(tgl_baru) }}
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <div>
      <CEditphoto />
    </div>

    <div
      v-if="session.authorities.some((item) => item === 'CRUD_ADMINISTRATOR')"
    >
      <v-dialog
        v-model="modal_statusdata"
        persistent
        max-width="30%"
        v-if="data.data"
      >
        <v-card class="pa-5">
          <div>
            <h3>STATUS DATA</h3>
          </div>

          <v-divider class="mt-3 mb-5"></v-divider>

          <div>
            <div>
              <v-select
                label="Status Data"
                v-model="data.data.status"
                :items="ref_status"
                outlined
                item-value="id"
                item-text="nama"
              ></v-select>
            </div>

            <div>
              <v-select
                label="Keterangan Data"
                v-model="data.statusData"
                :items="ref_data"
                outlined
                item-value="id"
                item-text="nama"
              ></v-select>
            </div>

            <div>
              <v-textarea
                label="Keterangan Tambahan"
                v-model="data.data.keterangan"
                outlined
              ></v-textarea>
            </div>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" dark @click="close_modal_statusdata()">
              BATAL
            </v-btn>
            <v-btn
              color="primary"
              :loading="lbtn"
              :disabled="lbtn"
              @click="update_statusdata()"
            >
              SIMPAN
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <div
      v-if="session.authorities.some((item) => item === 'CRUD_ADMINISTRATOR')"
    >
      <v-snackbar v-model="alertBerhasil" :timeout="4000" color="success">
        Berhasil Update Status Data
      </v-snackbar>

      <v-snackbar v-model="alertGagal" :timeout="4000" color="error">
        Gagal Update Status Data
      </v-snackbar>
    </div>

    <div class="mt-10">
      <router-view />
    </div>
  </div>
</template>

<script>
import Cookie from "@/helper/cookie.js";
import lib from "@/helper/lib.js";

import CEditphoto from "@/components/photo/edit";

import refreshView from "@/store/photo/refreshView";
import modal_editState from "@/store/photo/modal_edit";
import jabview from "@/store/asn/rwjabatan/viewRwjabatan";

export default {
  components: {
    CEditphoto,
  },

  computed: {
    refresh: {
      get() {
        return refreshView.state.Refresh;
      },
    },

    jabref: {
      get() {
        return jabview.state.Refresh;
      },
    },

    tgl_baru() {
      const dateStr = this.data.NCSISTIME;

      // ubah ke Date (ganti spasi jadi T biar aman)
      const date = new Date(dateStr.replace(" ", "T"));

      // tambah 3 bulan
      return date.setMonth(date.getMonth() + 3);
    },
  },

  watch: {
    refresh() {
      this.getFoto();
    },

    jabref() {
      this.getJabatan();
    },
  },

  data: () => ({
    token: Cookie.get("token"),
    session: "",
    lbtn: false,

    alertBerhasil: false,
    alertGagal: false,

    foto: "",

    modal_statusdata: false,
    ref_status: [
      {
        id: "active",
        nama: "Aktif",
      },
      {
        id: "inactive",
        nama: "Tidak Aktif",
      },
    ],

    ref_data: [
      {
        id: "lengkap",
        nama: "Lengkap",
      },
      {
        id: "belum lengkap",
        nama: "Belum Lengkap",
      },
      {
        id: "tidak lengkap",
        nama: "Tidak Lengkap",
      },
    ],

    data: {},
    rwjabatan: {},
  }),

  mounted() {
    this.session = JSON.parse(Cookie.dec(Cookie.get("myCookie")));
    this.getJabatan();
    this.getFoto();
    this.getData();
  },

  methods: {
    getData() {
      this.loading = true;

      const url =
        process.env.VUE_APP_ASN + "datautama/nip/" + this.$route.params.id;

      this.http
        .get(url, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((res) => {
          if (res.data.success) {
            this.data = res.data.mapData.DataUtama;
            this.loading = false;
          } else {
            console.log(res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getFoto() {
      const url = process.env.VUE_APP_ASN + "photos/" + this.$route.params.id;

      this.http
        .get(url, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
          responseType: "blob",
        })
        .then((response) => {
          refreshView.commit("refreshData", false);
          this.foto = URL.createObjectURL(response.data);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            // Auth.logout(this.token);
          } else if (error.response) {
            console.log(error.response.status);
          } else {
            console.log("Error", error.message);
          }
        });
    },

    getJabatan() {
      this.ldata = true;
      const url =
        process.env.VUE_APP_ASN + "posjab/nip/" + this.$route.params.id;

      this.http
        .get(url, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((response) => {
          this.ldata = false;
          let rwjabatans = response.data.mapData.data;
          this.rwjabatan = rwjabatans.at(-1);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            // Auth.logout(this.token);
          } else if (error.response) {
            console.log(error.response.status);
          } else {
            console.log("Error", error.message);
          }
        });
    },

    editPhoto() {
      modal_editState.commit("toggleModal", true);
    },

    open_modal_statusdata() {
      this.modal_statusdata = true;
    },

    close_modal_statusdata() {
      this.modal_statusdata = false;
    },

    update_statusdata() {
      this.lbtn = true;

      let data = {
        statusData: this.data.statusData,
        data: {
          status: this.data.data.status,
          keterangan: this.data.data.keterangan,
        },
      };

      const url =
        process.env.VUE_APP_ASN +
        "datautama/nip/" +
        this.$route.params.id +
        "/statusasn";

      this.http
        .put(url, data, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((response) => {
          if (response.data.success) {
            this.getData();
            this.alertBerhasil = true;
            this.alertGagal = false;
          } else {
            this.getData();
            this.alertBerhasil = false;
            this.alertGagal = true;
          }
          this.lbtn = false;
          this.modal_statusdata = false;
        })
        .catch((error) => {
          console.log(error.response.status);
          this.alertBerhasil = false;
          this.alertGagal = true;
          this.lbtn = false;
          this.modal_statusdata = false;
        });
    },

    fwaktu(value) {
      return lib.waktu(value);
    },
  },
};
</script>
